import request from '@/utils/request'

export function getCodeApi(data) {
  return request({
    url: `/auth/enterprise/sendMobileCode`,
    method: 'post',
    params: data
  })
}

// 登录
export function loginV4Api(data) {
  return request({
    url: `/auth/candidate/loginBySms`,
    method: 'POST',
    params: data,
    headers: {
      'device-type': '1',
      'device-id': navigator.userAgent,
      isToken:false,
    },
  })
}

// 获取用户详细信息
export function getInfo () {
  return request({
    url: '/auth/user/getInfoV2',
    method: 'get'
  })
}

// 获取用户详细信息
export function quitLogin () {
  return request({
    url: '/auth/candidate/logout',
    method: 'delete'
  })
}
